// @flow

import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';

class ScreenToggle extends PureComponent {
  static defaultProps = {
    location: {
      pathname: '',
    },
    history: {
      push: () => {},
    },
  };

  static propTypes = {
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
    }),
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }),
  };

  constructor(props) {
    super(props);
    const isHome = this.props.location.pathname === '/';
    const isMap = this.props.location.pathname === '/map';

    this.handleClick = this.handleClick.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.state = {
      isMap,
      isHome,
      isHidden: !(isMap || isHome),
      hasFocus: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if ('location' in nextProps) {
      const isHome = nextProps.location.pathname === '/';
      const isMap = nextProps.location.pathname === '/map';
      this.setState({
        isMap,
        isHome,
        isHidden: !(isMap || isHome),
      });
    }
  }

  handleClick(event) {
    const button = this.button;

    event.preventDefault();
    button.blur();

    if (this.state.isMap) {
      button.classList.remove('btn--switch-right');
      button.classList.add('btn--switch-left');
      this.props.history.push('/');
    } else {
      button.classList.remove('btn--switch-left');
      button.classList.add('btn--switch-right');
      this.props.history.push('/map');
    }

    this.setState({
      isMap: !this.state.isMap,
      isHome: !!this.state.isMap,
    });
  }

  handleFocus(event) {
    const { onFocus } = this.props;

    if (onFocus) {
      onFocus(event);
    }

    this.setState({ hasFocus: true });
  }

  handleBlur(event) {
    const { onBlur } = this.props;

    if (onBlur) {
      onBlur(event);
    }

    this.setState({ hasFocus: false });
  }

  render() {
    const switchClass = this.state.isMap
      ? 'btn--switch-left'
      : 'btn--switch-right';

    let toggleClass = 'is-hidden site-toggle--default';
    if (this.state.isHome && this.props.introFinished) {
      toggleClass = 'site-toggle--delayed animate--fade-in';
    } else if (this.state.isMap) {
      toggleClass = 'site-toggle--default';
    }

    return (
      <div
        className={`site-toggle center center--horizontally theme--aqua ${toggleClass}`}
      >
        <button
          ref={ref => {
            this.button = ref;
          }}
          onClick={this.handleClick}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
          className={`btn btn--default btn--outline btn--switch ${switchClass}`}
        >
          <span className="btn__switch btn__switch--left">
            <span className="btn__child btn__switch-text">Act View</span>
          </span>
          <span className="btn__switch btn__switch--right">
            <span className="btn__child btn__switch-text">Map View</span>
          </span>
          <span className="btn btn--arrow" />
        </button>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  introFinished: state.intro.hasFinished,
});

export default withRouter(connect(mapStateToProps, {})(ScreenToggle));



// WEBPACK FOOTER //
// ./screens/App/components/ScreenToggle/index.js